import Dexie from 'dexie'

export default class UserPreferenceManager {
    static instance: UserPreferenceManager
    static getInstance() {
        if (!this.instance) {
            this.instance = new UserPreferenceManager()
        }
        return this.instance
    }

    constructor() {
        this.db = new Dexie('userPreferenceDatabase')
        this.db.version(2).stores({
            eventPreferences: 'jid',
            cameraPreferences: 'jid',
        })
    }

    fetchEventPreferences(jid) {
        return this.db.eventPreferences.where('jid').equals(jid).first()
    }

    fetchCameraPreferences(jid) {
        return this.db.cameraPreferences.where('jid').equals(jid).first()
    }

    updateLastEventbookSeenAt(eventPreferences, lastEventbookSeenAt) {
        return this.db.eventPreferences.put({
            ...eventPreferences,
            lastEventbookSeenAt,
        })
    }

    updateLastEventCreatedAt(eventPreferences, lastEventCreatedAt) {
        return this.db.eventPreferences.put({
            ...eventPreferences,
            lastEventCreatedAt,
        })
    }

    updateTutorials(cameraPreferences, tutorialsStep) {
        return this.db.cameraPreferences.put({
            ...cameraPreferences,
            tutorialsStep,
        })
    }
}
